(function () {
    'use strict';

    angular.module('app').factory('EmbeddedService', EmbeddedService);

    EmbeddedService.$inject = ['API'];

    function EmbeddedService(API) {
        var service = {};

        /**
         * Return list of goods for embedded list
         * @param {Object} params - Parameters filter
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetGoods = function (params, callback) {
            API.get('/embedded/goods?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return special accounts for embedded list
         * @param {Object} params - Parameters filter
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetSpecialAccounts = function (params, callback) {
            API.get('/embedded/special_accounts?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return list of Staff for embedded lists
         * @param {Object} params - Parameters filter
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetStaff = function (params, callback) {
            API.get('/embedded/staff?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return list of Taxes for embedded lists
         * @param {Object} params - Parameters filter
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetTaxes = function (params, callback) {
            API.get('/embedded/taxes?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return list of Taxes for embedded lists
         * @param {Object} params - Parameters filter
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetAdditionalCosts = function (params, callback) {
            API.get('/embedded/additional_costs?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        };

        return service;
    }
})();
